import React from 'react';
import { Box } from '@mui/material';
import Text from '../atoms/Text.jsx';
import { classes } from '../../styles/FooterStyle.js';

function Footer() {
  return (
    <Box component="footer" sx={classes.footerSection}>
      <Box sx={classes.footerTop}>
        <Box sx={classes.aboutIntenceAI}>
          <Text variant="h3" sx={classes.aboutHeading}>
            IntenceAI
          </Text>
          <Text variant="p" sx={classes.aboutText}>
            IntenceAI is an AI-powered social media management platform that
            helps businesses, creators, and agencies streamline content
            creation, scheduling, and analytics across multiple accounts, grow
            your audience, and stay ahead of trends with smarter, data-driven
            tools.
          </Text>
        </Box>
        <Box sx={classes.footerLinks}>
          <Box component="nav" sx={classes.footerNav}>
            <Text variant="h4" sx={classes.footerNavHeading}>
              Pricing
            </Text>
            <Box component="ul" sx={classes.footerUl}>
              <li>
                <a href="#pricing" style={classes.footerLink}>
                  Pricing
                </a>
              </li>
              <li>
                <a href="#affiliates" style={classes.footerLink}>
                  Affiliates
                </a>
              </li>
              <li>
                <a href="#contact" style={classes.footerLink}>
                  Contact Us
                </a>
              </li>
            </Box>
          </Box>

          <Box component="nav" sx={classes.footerNav}>
            <Text variant="h4" sx={classes.footerNavHeading}>
              Support
            </Text>
            <Box component="ul" sx={classes.footerUl}>
              <li>
                <a href="#faq" style={classes.footerLink}>
                  FAQ
                </a>
              </li>
              <li>
                <a href="#terms" style={classes.footerLink}>
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a href="#google-api-disclosure" style={classes.footerLink}>
                  Google API Disclosure
                </a>
              </li>
              <li>
                <a href="#articles" style={classes.footerLink}>
                  Articles
                </a>
              </li>
            </Box>
          </Box>

          <Box component="nav" sx={classes.footerNav}>
            <Text variant="h4" sx={classes.footerNavHeading}>
              Alternatives
            </Text>
            <Box component="ul" sx={classes.footerUl}>
              <li>
                <a href="https://faceless.video" style={classes.footerLink}>
                  Faceless.video
                </a>
              </li>
              <li>
                <a href="https://vadoo.ai" style={classes.footerLink}>
                  Vadoo.ai
                </a>
              </li>
              <li>
                <a href="https://nullface.ai" style={classes.footerLink}>
                  Nullface AI
                </a>
              </li>
              <li>
                <a href="https://smartshot.ai" style={classes.footerLink}>
                  Smart Shot AI
                </a>
              </li>
              <li>
                <a href="https://crayo.ai" style={classes.footerLink}>
                  Crayo AI
                </a>
              </li>
              <li>
                <a href="https://aivideo.com" style={classes.footerLink}>
                  AIVideo.com
                </a>
              </li>
            </Box>
          </Box>

          <Box component="nav" sx={classes.footerNav}>
            <Text variant="h4" sx={classes.footerNavHeading}>
              Social
            </Text>
            <Box component="ul" sx={classes.footerUl}>
              <li>
                <a href="https://twitter.com" style={classes.footerLink}>
                  Twitter
                </a>
              </li>
              <li>
                <a href="https://youtube.com" style={classes.footerLink}>
                  Youtube
                </a>
              </li>
              <li>
                <a href="https://instagram.com" style={classes.footerLink}>
                  Instagram
                </a>
              </li>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={classes.footerBottom}>
        <Text variant="p">
          © {new Date().getFullYear()} IntenceAI. All rights reserved.
        </Text>
      </Box>
    </Box>
  );
}

export default Footer;
